import styled from "styled-components";

export const ArrowButtonContainer = styled.div<{ isOpen: boolean}>`
    position: fixed; 
    top: 20px;
    right: ${props => props.isOpen ? '20px' : '-200px'};
    display: flex;
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #2CAAE5;
    border-radius: 8px;
    padding: 16px;
    will-change: transform; 
    transform: translateZ(0);
    z-index: 1001;
    gap: 8px;
    cursor: pointer;
    transition: right 0.3s easew 
        
    &:hover {
        background: rgba(0, 0, 0, 0.9);
    }
`